export type Platform = 'android' | 'ios' | 'desktop';
export function detectPlatform(): Platform {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ios';
  return 'desktop';
}
export const isStandalone = (): boolean => window.matchMedia('(display-mode: standalone)').matches || (navigator as unknown as { standalone?: boolean }).standalone === true;

/** Fingerprint-ish string for duplicate-trial detection (coarse on purpose; sent only at signup / first shop). */
export function coarseFingerprint(): string {
  return [navigator.language, screen.width + 'x' + screen.height, devicePixelRatio, Intl.DateTimeFormat().resolvedOptions().timeZone, navigator.hardwareConcurrency ?? 0].join('|');
}
